export default (params) => ({
  trigger: {
    name: 'content_blocks.comparison.select_visual',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      title: {
        type: 'string',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_visual',
      params: {
        sub_feature: null,
        visual_type: 'image',
      },
    },
    nonInt: true,
  },
});
